import API from './API.js';
export default class Slider extends API {
    constructor() {
        super('slider');
    }

}
